import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

const DiscountLabel = ({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 14 14' {...props}>
    <Path
      d='M7.94311 6.09089C7.9756 6.12345 7.97555 6.17618 7.94302 6.20869C7.91048
         6.2412 7.85775 6.2412 7.82521 6.20869C7.79268 6.17618 7.79263 6.12345
         7.82511 6.09089C7.84075 6.07521 7.86198 6.06641 7.88411 6.06641C7.90625
         6.06641 7.92748 6.07521 7.94311 6.09089'
      stroke={color}
      fill={fill}
      stroke-width='0.999883'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <Path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M6.97481 4.23047H8.86681C9.36754 4.23047 9.77347 4.6364 9.77347
         5.13714V7.02847C9.77316 7.26915 9.67724 7.49985 9.50681 7.6698L7.10681
         10.0698C6.75253 10.4238 6.17842 10.4238 5.82414 10.0698L3.93347
         8.1798C3.57947 7.82552 3.57947 7.25141 3.93347 6.89714L6.33347
         4.49714C6.50342 4.3267 6.73412 4.23078 6.97481 4.23047V4.23047Z'
      stroke={color}
      fill={fill}
      stroke-width='0.999883'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <Rect
      x='1'
      y='1'
      width='12px'
      height='12px'
      rx='3.33294'
      stroke={color}
      fill={fill}
      stroke-width='0.999883'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </IconBase>
)

DiscountLabel.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default DiscountLabel
